/** The hover text of a field or board Tadpole keeps for everyone. */
export const TADPOLE_DATA_HINT =
  "Kept by Tadpole. It can't be renamed, retyped or deleted.";

/**
 * "Tt": a small monogram that marks Tadpole's own data (built-in CRM fields
 * and boards). Its hover text is also its accessible name.
 */
export default function TadpoleBadge({
  hint = TADPOLE_DATA_HINT,
}: {
  hint?: string;
}) {
  return (
    <span
      role="img"
      aria-label={hint}
      title={hint}
      className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border border-[color:var(--green)] bg-white text-[10px] font-bold leading-none text-[color:var(--green)]"
    >
      Tt
    </span>
  );
}
